import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Button } from "@mui/material";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { CommonGridToolBarWithFilterText } from "../../../Components/Common Components/CommonComponents";
import { CurrencySymbol } from "../../../Utility/Constants";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { CheckAccessFunc, GetStoreBaseUrl } from "../../../Components/CommonFunctions/CommonFunctions";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";


function StoreWantedList(props) {
    const { fromStore, loggedData } = props;
    const history = useHistory();
    const location = useLocation();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [delIDs, setdelIDs] = useState([]);
    const [wantedListData, setwantedListData] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [vendorMappList, setvendorMappList] = useState([]);
    let EditAccess = true
    if (loggedData?.module_name === "store_module") {
        EditAccess = (CheckAccessFunc("Store", "Purchase", "Wanted List", null, "Tab")?.editAccess)
    } else {
        EditAccess = (CheckAccessFunc("Store Sub Location", "Store", "Inbound", null, "Tab")?.editAccess)
    }


    useEffect(() => {
        getwantedListData()
        if (location.states?.success_message) {
            successMessage(location.states?.success_message)
            history.push({ states: {...location?.states, success_message : "" } })
        }
    }, [])

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const errorMessage = (msg) => {
        setisloader(false)
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setisloader(false)
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getwantedListData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(fromStore ? Serviceurls.STORE_WANTED_LIST : Serviceurls.STORE_SUBLOC_WANTED_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        let WantedList = response.data.data || []
                        if (fromStore) {
                            getvendorMapping(WantedList)
                        } else {
                            setwantedListData(WantedList)
                        }
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getvendorMapping = (WantedListData = []) => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_VENDOR_MAPPING)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setvendorMappList(response.data.data?.filter((item) => item?.is_active) || [])
                        let WantedList = WantedListData?.map(list => ({
                            ...list,
                            MappedVendor: response.data.data?.filter(item => item?.is_active && item?.sub_category_id === list?.sub_category_id).map(item => item?.vendor_id)
                        }));
                        setwantedListData(WantedList)
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const handleCheckChange = (id) => {
        setwantedListData((prevRows) =>
            prevRows.map((row, index) =>
                (index + 1) === id ? {
                    ...row,
                    selected: !row.selected,
                    quantity: !row.selected ? row?.roq_quantity : "",
                } : row
            )
        );
    }

    const CheckvalidProducts = (NeedVenderId = false) => {
        let arrayOfArrays = wantedListData?.filter((list) => (list?.selected))?.map((list) => (list?.MappedVendor))
        let FilteredArray = wantedListData?.filter((list) => (list?.selected))
        if (!arrayOfArrays || arrayOfArrays.length === 0) {
            errorMessage(`All products is not mapped with any vendor.`);
            return false;
        }

        for (let i = 0; i < arrayOfArrays.length; i++) {
            if (!arrayOfArrays[i] || arrayOfArrays[i].length === 0) {
                errorMessage(`${FilteredArray[i]?.product_name} is not mapped with any vendor.`);
                return false;
            }
        }

        if (arrayOfArrays.length === 1) {
            return arrayOfArrays[0][0];
        }

        const firstArray = arrayOfArrays[0];
        const firstSet = new Set(firstArray);
        let invaildIndex = null;
        let SingleVendor = null
        for (const value of firstSet) {
            let isCommon = true;
            for (let i = 1; i < arrayOfArrays.length; i++) {
                if (!arrayOfArrays[i].includes(value)) {
                    invaildIndex = i
                    isCommon = false;
                    break;
                }
            }
            if (isCommon) {
                console.log("common - ", value)
                return value;
            }
        }
        errorMessage(`${FilteredArray[invaildIndex]?.product_name} is mapped to a different vendor. The selected product must be mapped to a single vendor.`);
        return false;
    }

    const tableView = () => {
        try {
            const gridToolBar = () => {
                return (
                    <Box>
                        <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} />
                    </Box>
                )
            }

            wantedListData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: "select",
                    headerName: "",
                    flex: 0.03,
                    renderCell: (params) => (
                        <Checkbox
                            checked={params.row.selected || false}
                            onChange={() => handleCheckChange(params.row.sno)}
                        />
                    ),
                },
                {
                    field: 'product_code', headerName: 'Product Code', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.product_code || '-'}</Box>)

                },
                {
                    field: 'product_name', headerName: 'Product Name', flex: 0.09,
                    renderCell: (params) => (params.row.product_name ? params.row.product_name?.length > 12 ?
                        <Tooltip placement="top" title={params.row.product_name}><Typography fontSize={'0.9vw'}>{params.row.product_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.product_name || '-'}</Typography> : '-')
                },
                {
                    field: 'category_name', headerName: 'Category', flex: 0.09,
                    renderCell: (params) => (params.row.category_name ? params.row.category_name?.length > 12 ?
                        <Tooltip placement="top" title={params.row.category_name}><Typography fontSize={'0.9vw'}>{params.row.category_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.category_name || '-'}</Typography> : '-')
                },
                {
                    field: 'department_name', headerName: 'Department Name', flex: 0.09,
                    renderCell: (params) => (params.row.department_name ? params.row.department_name?.length > 12 ?
                        <Tooltip placement="top" title={params.row.department_name}><Typography fontSize={'0.9vw'}>{params.row.department_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.department_name || '-'}</Typography> : '-')
                },
                {
                    field: 'total_quantity', headerName: 'Available Qty', flex: 0.06,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.total_quantity || '-'}</Box>)
                },
                {
                    field: 'reorder_threshold', headerName: 'ROL', flex: 0.06,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.reorder_threshold || '-'}</Box>)
                },
                {
                    field: 'quantity', headerName: 'Request Quantity', flex: 0.05,
                    renderCell: (params) => (
                        <Box component={'div'}>
                            <TextField
                                disabled={params?.row?.selected ? false : true}
                                inputProps={{ style: { height: '4vh', padding: '0 14px' }, maxLength: 4 }}
                                autoComplete='off'
                                size="small"
                                value={params.row?.quantity ? params.row?.quantity : ""}
                                onChange={(e) => {
                                    if (CommonValidation.numberOnly(e.target.value) || e.target.value === '') {
                                        setwantedListData((prevRows) =>
                                            prevRows.map((row, index) =>
                                                (index + 1) === params.row.sno ? {
                                                    ...row,
                                                    quantity: e.target?.value,
                                                } : row
                                            )
                                        );
                                    }
                                }}
                                className='eMed_DataGrid_TextField' />
                        </Box>
                    )
                },
            ];
            return (
                <Box sx={{ height: '70vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={wantedListData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='standard'
                        disableSelectionOnClick
                        loading={isloader}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box display={'flex'} justifyContent={'flex-end'} flexDirection={'row'} alignItems={'center'}>
                {EditAccess ? <Button size="small" disabled={wantedListData?.every((list) => (!list?.selected))} variant="contained" sx={{ textTransform: 'capitalize' }} onClick={() => {
                    if (wantedListData?.some((list) => (!list?.quantity && list?.selected))) {
                        errorMessage("Please enter request quantity")
                    } else {
                        if (loggedData?.module_name === 'store_module') {
                            if (CheckvalidProducts()) {
                                history.push({ pathname: "/StorePurchase/PurchaseRequest/Add", states: { line_items: wantedListData?.filter((list) => (list?.selected)), from_wanted_list: true, vendor_id: CheckvalidProducts() } })
                            }
                        } else {
                            history.push({ pathname: `${GetStoreBaseUrl()}/IndentRise/Add`, states: { line_items: wantedListData?.filter((list) => (list?.selected)), from_wanted_list: true } })
                        }
                    }
                }}>Raise Request</Button> : null}
            </Box>
            <Box>
                {tableView()}
            </Box>
            {console.log(wantedListData)}
            {(errorMsg && errorMsgText) ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {(successMsg && successMsgText) ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
};

export default StoreWantedList;

